module.exports = __webpack_public_path__ + "img/icon_search_04.5a5ad4e1.png";